import Image from "next/image";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/i18n/navigation";
import { projectBannerUrl } from "@/lib/project-meta";
import type { components } from "@/types/api/api-types";

export const CheckoutProjectCard = ({
  id,
  name,
  logo_url,
  banner_url,
  meta,
}: components["schemas"]["ProjectResponseDto"]) => {
  return (
    <Link href={`/fast-checkout/${id}`}>
      <Card className="bg-bg-secondary w-full rounded-sm">
        <CardContent className="flex flex-col items-center space-y-3 p-3">
          <div className="relative max-h-45 w-full h-full aspect-square">
            <Image
              src={
                meta?.render_image === "banner"
                  ? projectBannerUrl(meta, banner_url, "checkout")
                  : logo_url
              }
              alt="project-card-bg"
              className="w-full h-auto rounded-sm object-cover"
              fill
              sizes="(max-width: 640px) 50vw, 250px"
            />
          </div>
          <p className="text-center text-sm font-semibold">{name}</p>
        </CardContent>
      </Card>
    </Link>
  );
};
